<!--result-view-questionare-->
<div class="content md3-surface">
  <div class="layout-auto-1 app-qba-task-questionnaire md3-card-on-surface">

    <div class="span-layout header search">
      <div class="search-input-bar">
        {{Data?.qcfgName}} - {{getRessource('Questionnaire')}}</div>
      <div>
        <!--<i class="search-action fa fa-check" *ngIf="isEndable()" (click)="openTaskFinishModal()"></i>-->
      </div>
    </div>

    <div class="content grid-auto-1-auto">
      <!-- Help Drawer -->
      <div class="drawer-container left" style="padding: 0;">
        <div class="drawer-content width-400" [ngClass]="{'visible': drawer}">
          <i class="search-action far fa-times questionnaire-drawer-closer" style="z-index: 1000;" (click)="closeDrawer()"></i>
          <div class="layout-auto-1">
            <h5 class="questionnaire-drawer-header" style="padding: 0 0;">{{getRessource('Help')}}</h5>
            <div class="content" style="padding: 0 1rem;">
              <div [innerHTML]="selectedHelpText">
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- Chapter List -->
      <div class="content app-content-left">

        <div class="layout-auto-1" *ngIf="Data.Chapters">
          <div></div>

          <div class="layout-auto-1-auto" style="min-width: 375px;">
            <div></div>
            <div class="content">
              <ng-container *ngFor="let row of Data.Chapters; let i = index;">
                <div class="list-row  list-single-line list-row-1-auto" (click)="onRowSelect(i)"
                     [ngStyle]="{'background-color': (row.questHexCode !== null)? row.questHexCode : ''}">
                <span class="list-primary-text"
                      [ngStyle]="{'margin-left.rem':  row.questIdentation}">{{row.quest_Ident}}&nbsp;{{row.questText}}
                  <p style="margin: 0px;">
                     <span [ngClass]="row.resultpercent<100? 'text-y-500': 'green'" *ngIf="row.QuestionsCount > 0"
                           style="font-size: smaller; width: 100%; padding: 0px;">
                               {{row.ResultCount}}
                       /{{row.QuestionsCount}} {{getChapterPercent(row.resultpercent, row.QuestionsCount)}}
                     </span>
                  </p>
                </span>
                  <span class="list-metadata" *ngIf="row.segName">{{row.segName}}

                  </span>
                </div>
              </ng-container>
            </div>
          </div>
        </div>

      </div>

      <!-- Questionnaire Content -->
      <div class="content">

        <div class="layout-1-auto">

          <!-- Loading Content -->
          <div class="content" *ngIf="isLoading">
            <div class="splash loading"><div class="spinner"><div></div><div></div><div></div><div></div></div></div>
          </div>

          <div class="content" style="padding: 1.5rem 0;" *ngIf="questionnaireList && selectedChapter && !isLoading">
            <!-- Chapter Header -->
            <div class="app-quest-chapter" *ngIf="selectedChapter">
              <div *ngIf="selectedChapter?.FileStream"></div>
              <img *ngIf="selectedChapter?.FileStream" class="app-quest-chapter-image"
                   src="{{getImageSrc(selectedChapter?.FileStream, selectedChapter?.MIME)}}"
                   (click)="toggleZoom($event, selectedChapter)"
                   alt="{{selectedChapter.questID}}">
              <span class="app-quest-pretext-chapter"
                    *ngIf="selectedChapter?.questPreText || selectedChapter?.questLink">
                {{selectedChapter.questPreText}}&nbsp;
                  <a [href]="selectedChapter?.questLink" target="_blank"

                     *ngIf="selectedChapter?.questLink">
                     {{selectedChapter.questLinkText ? selectedChapter.questLinkText : getRessource('LinkText')}}
                  </a>
                </span>
              <div class="app-quest-chapter-icon">
                <i *ngIf="selectedChapter.questHelp" class="far fa-info-circle pointer"
                   (click)="toggleDrawer(selectedChapter.questHelp)" [tooltip]="getRessource('Help')"
                   flow="down"></i>
              </div>
              <h5>
                {{selectedChapter.quest_Ident}} – {{selectedChapter.questText}}</h5>
            </div>
            <!-- Questionnaire -->
            <form #questionnaire="ngForm" [name]="'Questionnaire' + ComponentUID" *ngIf="questionnaireList !== []" exgPreventDefault>
              <div *ngFor="let item of questionnaireList; index as x">
                <!-- Subchapter Header -->
                <div class="app-quest-subchapter"
                     *ngIf="[1].includes(item.quest_enmIdent_questType) && !isConditionalAndNotValid(item) && item.questParentkey && item?.questID !== selectedChapter?.questID">
                   <span class="app-quest-pretext-chapter" *ngIf="item?.questPreText || item?.questLink">
                {{item.questPreText}}&nbsp;
                  <a [href]="item?.questLink" target="_blank"
                     style="text-decoration: none; align-self: flex-end; color: var(--c-ctrl-text);"
                     *ngIf="item?.questLink">
                      {{item?.questLinkText ? item?.questLinkText : getRessource('LinkText')}}
                  </a>
                </span>
                  <div *ngIf="item?.FileStream"></div>
                  <img *ngIf="item?.FileStream" class="app-quest-chapter-image"
                       src="{{getImageSrc(item?.FileStream, item?.MIME)}}"
                       (click)="toggleZoom($event, item)"
                       alt="{{item.questID}}">
                  <div class="app-quest-subchapter-icon">
                    <i *ngIf="item.questHelp" class="far fa-info-circle pointer"
                       (click)="toggleDrawer(item.questHelp)" [tooltip]="getRessource('Help')" flow="down"></i>
                  </div>
                  <h5>
                    {{item.quest_Ident}} – {{item.questText}}</h5>
                </div>
                <!-- Question Header -->
                <div class="app-qba-questionnaire-question"
                     *ngIf="[2].includes(item.quest_enmIdent_questType) && !isConditionalAndNotValid(item) && item.questParentkey">
                  <div class="question-menu-icon"
                       *ngIf="[1,2].includes(item.quest_enmIdent_questType) && item.questPreText || item.questLink"
                       style=" place-items: start; padding-left: 5px;">

                  </div>
                  <div
                    *ngIf="[2].includes(item.quest_enmIdent_questType) && item.questPreText || item.questLink || item?.FileStream">
                    <img *ngIf="item?.FileStream " class="app-quest-chapter-image" (click)="toggleZoom($event,item)"
                         src="{{getImageSrc(item?.FileStream, item?.MIME)}}" alt="{{item.questID}}">
                    <span class="app-quest-pretext-chapter" *ngIf="item.questPreText || item.questLink">
                           {{item.questPreText}}
                      <a *ngIf="item.questLink" target="_blank" [href]="item.questLink">
                     {{item?.questLinkText ? item?.questLinkText : getRessource('LinkText')}}
                    </a></span>

                  </div>
                  <div class="question-menu-icon">
                    <i class="span-1 far fa-fw fa-info-circle pointer"
                       *ngIf="item.questHelp !== null && item.questHelp !== ''" [tooltip]="getRessource('Help')"
                       flow="down"
                       (click)="toggleDrawer(item.questHelp)"></i>
                  </div>
                  <div class="question-text" *ngIf="[1,2].includes(item.quest_enmIdent_questType) ">
                    <em>{{item.quest_Ident}} - {{item.questText}}
                      <i class="far fa-asterisk app-quest-question-marker" *ngIf="!item.questIsOptional"></i>
                    </em>
                  </div>
                </div>
                <div class="app-qba-questionnaire-answer" [ngClass]="getClass(questionnaireList, item, x)"
                     [ngStyle]="{'padding-left': (item.questHelp !== null && item.questHelp !== '' && item.quest_enmIdent_questType===3)? '0': ''}">
                  <!-- Yes/No- One Choice -->
                  <div *ngIf="(item.quest_enmIdent_questValueFormat === 1 || item.quest_enmIdent_questValueFormat === 2) && item.quest_enmIdent_questType===3
                  && !isConditionalAndNotValid(getParent((item)))" class="grid-auto-1">

                    <div *ngIf="item.questHelp !== null && item.questHelp !== ''"
                      style="display: grid; place-items: center; width: 2rem;color: var(--c-ctrl-text);font-size: 1.125rem">
                      <i class="span-1 far fa-fw fa-info-circle pointer" [tooltip]="getRessource('Help')" flow="down"
                         (click)="toggleDrawer(item.questHelp)"></i>
                    </div>

                    <div>
                      <input type="radio" [checked]="parentValue(item)"
                             [name]="item.quest_enmIdent_questValueFormat+item.questKey" (click)="radioInput($event, item)"
                             [disabled]="isDisabledParent(item) || isSkipped(getParent(item))"
                             [value]="item.questText" [id]="item.questID">
                      <label [attr.for]="item.questID">{{ item.questText }}</label>
                      <label *ngIf="item.questIsKO">{{' (K.O)'}}</label>
                    </div>
                    <!--<i class="far fa-fw fa-circle-info text-n-600"
                         *ngIf="item.conditions"
                         style="display: inline-block;"
                         (click)="togglePopupMenu($event, item.conditions)"
                         [tooltip]="item.conditions" flow="down">
                      </i>-->
                  </div>

                  <!-- Multiple Choice -->
                  <div class="grid-auto-1" [ngClass]="{'disabled': isDisabledParent(item)}"
                    *ngIf="item.quest_enmIdent_questValueFormat === 3 && item.quest_enmIdent_questType === 3 && !isConditionalAndNotValid(getParent((item)))">
                    <div *ngIf="item.questHelp !== null && item.questHelp !== ''"
                         style="display: grid; place-items: center; width: 2rem;color: var(--c-ctrl-text);font-size: 1.125rem">
                      <i class="span-1 far fa-fw fa-info-circle pointer" [tooltip]="getRessource('Help')" flow="down"
                         (click)="toggleDrawer(item.questHelp)"></i>
                    </div>
                    <div>
                      <input type="checkbox" [name]="item.questID" [checked]="item.Answered"
                             [disabled]="isDisabledParent(item) || isSkipped(getParent(item))"
                             [id]="item.questID" (click)="checkBoxInput($event, item)">
                      <label [attr.for]="item.questID">{{item.questText}}</label>
                      <label *ngIf="item.questIsKO">{{' (K.O)'}}</label>
                    </div>
                  </div>

                  <!-- File Upload -->
                  <div *ngIf="item.quest_enmIdent_questValueFormat === 4" class="">
                    <button
                      *ngIf="isValidToEdit() && isNotConditionalOrValid(item)"
                      [disabled]="isDisabled(x) || isSkipped(item)"
                      (filesSelect)="fileUpload($event, item)" appExgDirectUploadV2 [dnd]="true" #My class="md-btn-outline"
                      [multiple]="true">
                      <i class="fa-fw fas fa-upload"></i>{{' ' + getRessource('AddDocument')}}</button>
                    <button *ngIf="item.cmpValue > 0 && !isSkipped(item)" class="md-btn"
                            (click)="openAttachmentViewer(item)"><i
                      class="fa-fw fas fa-pencil">
                    </i> {{item.cmpValue}} {{getRessource('Documents')}} </button>
                  </div>

                  <!-- Picture Upload -->
                  <div *ngIf="item.quest_enmIdent_questValueFormat === 5" class="">
                    <button class="md-btn-outline"
                            *ngIf="isValidToEdit() && isNotConditionalOrValid(item)"
                            [disabled]="isDisabled(x) || isSkipped(item)"
                            appExgDirectUploadV2 (filesSelect)="fileUpload($event, item)"><i
                      class="fa-fw fas fa-upload"></i>{{' ' + getRessource('AddPictures')}}</button>
                    <button *ngIf="item.cmpValue > 0  && !isSkipped(item)" class="md-btn"
                            (click)="openAttachmentViewer(item)"><i
                      class="fa-fw fas fa-pencil"></i>&nbsp;{{item.cmpValue}} {{getRessource('Pictures')}}</button>
                  </div>

                  <!-- Signature -->
                  <!--<div *ngIf="x.quest_enmIdent_questValueFormat === 6">
                    <i class="fa-btn fas fa-fw fa-pen" (click)="sigPad.toggleFullScreen()"></i>
                    <lib-exc-signature-pad class="" (hasImage)="handleHasImage($event)" #sigPad></lib-exc-signature-pad>
                  </div>-->

                  <!-- Single line input -->
                  <input *ngIf="item?.quest_enmIdent_questValueFormat === 7 && !isConditionalAndNotValid(item)"
                         [(ngModel)]="item.rstValue" type="text"
                         class="" [name]="item.questID" [disabled]="isDisabled(item) || isSkipped(item)"
                         [id]="item.questID"
                         ng-model-options="{allowInvalid: true}" (change)="saveQuestionnaireAnswer(item)"/>

                  <!-- Multi line input -->
                  <div *ngIf="item.quest_enmIdent_questValueFormat === 8 && !isConditionalAndNotValid(item)"
                       style="margin: -1rem 0.5rem 0 0;"
                       class="app-quest-textarea wrap">
                    <div class="pull-tab"></div>
                    <div class="pull-tab small"></div>
                    <textarea [(ngModel)]="item.rstValue"
                              (keydown.enter)="$event.stopPropagation()"
                              class=""
                              style="width: 480px; height: 160px"
                              [disabled]="isDisabled(item) || isSkipped(item)"
                              [name]="item.questID"
                              [id]="item.questID"
                              (change)="saveQuestionnaireAnswer(item)">
                    </textarea>
                  </div>
                  <!-- Ganzzahlen  -->
                  <input *ngIf="item.quest_enmIdent_questValueFormat === 9 && !isConditionalAndNotValid(item)"
                         [(ngModel)]="item && item.rstValue"
                         type="number" [id]="item.questID"
                         [name]="item.questID" class="" [disabled]="isDisabled(item)  || isSkipped(item)" min="0"
                         (blur)="saveQuestionnaireAnswer(item)"/>

                  <!-- Kommazahlen -->
                  <input *ngIf="item.quest_enmIdent_questValueFormat === 10 && !isConditionalAndNotValid(item)"
                         [(ngModel)]="item.rstValue"
                         [name]="item.questID" class="" [disabled]="isDisabled(item)  || isSkipped(item)"
                         [id]="item.questID" type="number" pattern="^(\d|,)*\.?\d*$"
                         (blur)="saveQuestionnaireAnswer(item)"/>

                  <!-- Prozentwert -->
                  <input *ngIf="item.quest_enmIdent_questValueFormat === 11 && !isConditionalAndNotValid(item)"
                         [(ngModel)]="item.rstValue"
                         [name]="item.questID" [disabled]="isDisabled(item) || isSkipped(item)" type="number"
                         [id]="item.questID" class="" min="0" max="100" pattern="^[1-9][0-9]?$|^100$"
                         (blur)="saveQuestionnaireAnswer(item)"/>

                  <!-- Currency -->
                  <input [(ngModel)]="item.rstValue" [allowNegativeNumbers]="true" thousandSeparator="." decimalMarker="," mask="separator.2"
                         [name]="item.questID" [disabled]="isDisabled(item) || isSkipped(item)" type="text"
                         [id]="item.questID"
                         *ngIf="item.quest_enmIdent_questValueFormat === 12 && !isConditionalAndNotValid(item)"
                         (change)="saveQuestionnaireAnswer(item)"/>

                  <!-- Datum -->
                  <input class="" style="width: 15ch;" [(ngModel)]="item.rstValue"
                         [name]="item.questID" [id]="item.questID" type="date"
                         [disabled]="isDisabled(item)  || isSkipped(item)"
                         [ngClass]="{'disabled': isDisabled(item)}"
                         (blur)="saveQuestionnaireAnswer(item)"
                         *ngIf="item.quest_enmIdent_questValueFormat === 13 && !isConditionalAndNotValid(item)"/>

                  <!-- Uhrzeit -->
                  <input class="" style="width: 15ch;" type="time" [(ngModel)]="item.rstValue"
                         [disabled]="isDisabled(item)  || isSkipped(item)"
                         [name]="item.questID" [id]="item.questID"
                         *ngIf="item.quest_enmIdent_questValueFormat === 14 && !isConditionalAndNotValid(item)"
                         (blur)="saveQuestionnaireAnswer(item)"/>

                  <!-- Wertung -->
                  <div class="progress-warning" style="font-size: 1.5rem; cursor: pointer" [id]="item.questKey"
                       *ngIf="item.quest_enmIdent_questValueFormat === 15 && (isValidToEdit() && isNotConditionalOrValid(item) && !isSkipped(item))">
                    <i class="fa-fw fa-star pointer" (click)="setRatingInputValue(item, 1)"
                       [ngClass]="{'fas': item.rstValue >= 1, 'far': item.rstValue < 1}"></i>
                    <i class="fa-fw fa-star pointer" (click)="setRatingInputValue(item, 2)"
                       [ngClass]="{'fas': item.rstValue >= 2, 'far': item.rstValue < 2}"></i>
                    <i class="fa-fw fa-star pointer" (click)="setRatingInputValue(item, 3)"
                       [ngClass]="{'fas': item.rstValue >= 3, 'far': item.rstValue < 3}"></i>
                    <i class="fa-fw fa-star pointer" (click)="setRatingInputValue(item, 4)"
                       [ngClass]="{'fas': item.rstValue >= 4, 'far': item.rstValue < 4}"></i>
                    <i class="fa-fw fa-star pointer" (click)="setRatingInputValue(item, 5)"
                       [ngClass]="{'fas': item.rstValue >= 5, 'far': item.rstValue < 5}"></i>
                  </div>
                  <div class="progress-warning" style="font-size: 1.5rem" [id]="item.questKey"
                       *ngIf="item.quest_enmIdent_questValueFormat === 15 && (!isValidToEdit() || !isNotConditionalOrValid(item) || isSkipped(item))">
                    <i class="fa-fw fa-star"
                       [ngClass]="{'fas': item.rstValue >= 1, 'far': item.rstValue < 1}"></i>
                    <i class="fa-fw fa-star"
                       [ngClass]="{'fas': item.rstValue >= 2, 'far': item.rstValue < 2}"></i>
                    <i class="fa-fw fa-star"
                       [ngClass]="{'fas': item.rstValue >= 3, 'far': item.rstValue < 3}"></i>
                    <i class="fa-fw fa-star"
                       [ngClass]="{'fas': item.rstValue >= 4, 'far': item.rstValue < 4}"></i>
                    <i class="fa-fw fa-star"
                       [ngClass]="{'fas': item.rstValue >= 5, 'far': item.rstValue < 5}"></i>
                  </div>

                  <!-- Tag Input -->
                  <div class="chip-container"
                       *ngIf="item?.quest_enmIdent_questValueFormat === 16 && !isConditionalAndNotValid(item)">
                    <div *ngFor="let chip of getArray(item.rstValue); let i= index" class="chip" tabindex="{{i}}">
                      <span>{{chip}}</span>
                      <i class="fa fa-close"
                         [ngClass]="!isDisabled(item)  && !isSkipped(item)? 'pointer' : ''"
                         (click)="removeTagInputChip(chip, item)"></i>
                    </div>

                    <input type="text" [disabled]="isDisabled(item) || isSkipped(item)" [name]="item.questID"
                           [id]="item.questID" [placeholder]="getRessource('InputTags')" (change)="onTagInputEnter($event,item)"
                           (keyup.enter)="onTagInputEnter($event,item)" autocomplete="off">
                  </div>

                  <!-- Table -->
                  <div *ngIf="item?.quest_enmIdent_questValueFormat === 17 && !isConditionalAndNotValid(item)">
                    <div class="grid">
                      <table id="myTable" class="questionnaire-table">
                        <tr>
                          <th></th>
                          <th class="pointer" *ngFor="let col of item.configs[0].cols; let j = index">{{col.y}}</th>
                        </tr>
                        <tr *ngFor="let row of item.configs; let i = index" class="pointer">
                          <td style="width:50%;text-align: left;">
                                    <span>{{ row.x }}
                                    </span></td>
                          <td *ngFor="let cell of row.cols; let k = index"
                              class="pointer">
                            <!-- {{ cell.score   }}{{isChecked(i, k , item)}}-->
                            <input type="checkbox" [name]="'chb' + item.questID + i + k"
                                   [checked]="isChecked(i, k , item)"
                                   [disabled]="isDisabledParent(item)"
                                   [id]="'chb' + item.questID" (change)="changeMatrixCheck(item, i, k)">
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>

                  <!-- Custom Form -->
                  <div *ngIf="item?.quest_enmIdent_questValueFormat === 18 && !isConditionalAndNotValid(item)">
                    <app-exg-form-submit [submitText]="getGlobal('Save')" class="app-custom-html"
                                         [formIdent]="'form' + item.questKey + 'CmpID' + ComponentUID"
                                         [forceDisable]="!isValidToEdit() || isConditionalAndNotValid(item) || isSkipped(item)"
                                         [htmlForm]="item.questConfiguration"
                                         [formValues]="item.rstValue"
                                         (formSubmit)="setFormSubmit($event, item)"
                    ></app-exg-form-submit>
                  </div>

                  <!-- Object List -->
                  <div *ngIf="item?.quest_enmIdent_questValueFormat === 19 && !isConditionalAndNotValid(item)">
                    <app-exg-object-list [submitText]="getGlobal('Save')"
                                         [formIdent]="'objectList' + item.questKey + 'CmpID' + ComponentUID"
                                         [forceDisable]="!isValidToEdit() || isConditionalAndNotValid(item) || isSkipped(item)"
                                         [objectMeta]="getJSONObject(item.questConfiguration)"
                                         [values]="item.rstValue"
                                         (formSubmit)="setFormSubmit($event, item)"
                    ></app-exg-object-list>
                  </div>

                  <!-- Skip Question -->
                  <div style="margin-top:0.5rem;font-size: small; color:var(--c-dark-300);"
                       *ngIf="isSkippedItem(item,x)">
                    <input type="checkbox" [name]="'chb' + item.questID"
                           [checked]="(isSkipped(getParent(item)) || isSkipped(item))"
                           [disabled]="isDisabledParent(item)"
                           [id]="'chb' + item.questID" (change)="checkBoxSkipable(item)">
                    <label [attr.for]="'chb' + item.questID">{{getRessource('InputN/A')}}</label>
                  </div>
                </div>
                <div *ngIf="questionnaireList.length-1 === x" style="margin-bottom: 2rem;"></div>
              </div>
            </form>
          </div>

        </div>

      </div>

    </div>

    <!-- Footer -->
    <div class="span-layout footer" style="line-height: 2.5rem;">
      {{getRessource('QuestionAnswered', {
      questionsAnswered: Data.QuestionnaireStatistics?.ResultCount,
      questionsTotal: Data.QuestionnaireStatistics?.QuestionsCount
    })}}
      <div class="pbar">
        <ng-container *ngFor="let item of fake;index as i;">
          <span class="pbar-item" [ngClass]="{'active': i+1<=fakeCurrent}">
          </span>
        </ng-container>
      </div>
    </div>

  </div>
</div>
<exg-popup #popUp [closeAlways]="false" width="360">
  <div class="md-menu-header">{{getRessource('ConditionalList')}}</div>
  <span style=" display: block; padding: 0.5rem" *ngFor="let x of getFormattedText()">{{x}}</span>
</exg-popup>
<exg-popup #image [closeAlways]="false" width="700">
  <div class="md-menu-header"></div>
  <div class="md-menu content" style="max-height: 500px; max-width: 700px">
    <div class="layout-1-auto">
      <img *ngIf="selectedQuest?.FileStream" style="width: 100%; padding: 20px;"
           src="{{'data:' + selectedQuest?.MIME + ';base64,' + selectedQuest?.FileStream}}" alt="ZoomedImage">
    </div>
  </div>
</exg-popup>
